export const CATEGORY_PAGE_REFERRER = 'category-page';
export const SIMPLEX_PAGE_REFERRER = 'simplex-page';
